export default __webpack_public_path__ + "static/media/widget-sentiment-dashboard.284351b3.png";